// @flow
import React, { type Ref } from 'react'
import classNames from 'classnames/bind'

import { Tr, Th, getPropsId } from 'app/common/ui-components/table'

import styles from './TableTHead.module.scss';

const cx = classNames.bind(styles)

type Props = {
  reference?: Ref<'tr'>,
  hidden?: boolean,
  dummy?: boolean,
  titles: Array<string>,
  columns: Array<string>,
}

const OrgsOrdersTableTHead = ({ reference, hidden, dummy, titles, columns }: Props) => {
  const cellProps = getPropsId(dummy)

  return (
    <Tr reference={reference} hidden={hidden} headerHasBorderBottom={false} header>
      {columns.map((columnId, i) => (
        <Th
          key={columnId}
          alignLeft
          contentClassName={cx({ statusHeader: columnId === 'id' })}
          {...cellProps(columnId)}
        >
          {titles[i]}
        </Th>
      ))}
    </Tr>
  )
}

export default OrgsOrdersTableTHead
